import React, { Component } from 'react'
import CompanyDetailsSection, {
  checker,
} from '../components/CompanyDetailsSection'
import { Button, Text } from 'components/base'

const FIELDS_MAP = {
  companyName: 'addressName',
  vatId: 'vatId',
  address: 'addressLine1',
  address2: 'addressLine2',
  city: 'addressCity',
  zip: 'addressPostalCode',
  state: 'addressState',
  country: 'addressCountry',
  email: 'billingEmail',
}

function convertFromPaymentInfo(paymentInfos) {
  return Object.keys(FIELDS_MAP).reduce(function(values, key) {
    return {
      ...values,
      [key]: paymentInfos[FIELDS_MAP[key]] || '',
    }
  }, {})
}

function convertToPaymentInfo(companyDetails) {
  return Object.keys(FIELDS_MAP).reduce(function(values, key) {
    return {
      ...values,
      [FIELDS_MAP[key]]: companyDetails[key],
    }
  }, {})
}

export default class UpdateDetailsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      companyDetails: convertFromPaymentInfo(this.props.paymentInfos),
    }
  }

  render() {
    return (
      <div>
        <Text.Subtitle>Update company details</Text.Subtitle>
        <div className="font-size-small shade-20 padding-vertical-large">
          This information will be included in all your future invoices.
        </div>
        <CompanyDetailsSection
          values={this.state.companyDetails}
          errors={this.state.companyDetailsErrors}
          onChange={this.onCompanyDetailsChange}
        />
        <div className="flexbox flexbox-space-between width-full">
          <Button.Secondary onClick={this.props.onCancel}>
            Cancel
          </Button.Secondary>
          <Button.Primary
            disabled={this.state.companyDetailsErrors || this.props.loading}
            onClick={this.onSave}
          >
            {this.props.loading ? 'Saving...' : 'Save'}
          </Button.Primary>
        </div>
      </div>
    )
  }

  onCompanyDetailsChange = companyDetails => {
    const companyDetailsErrors = checker(companyDetails)

    this.setState({
      companyDetailsErrors,
      companyDetails,
    })
  }

  onSave = () => {
    this.props.onSave(convertToPaymentInfo(this.state.companyDetails))
  }
}
